import axios, { AxiosResponse } from 'axios';

import AddSampleTypeInput from 'modules/Global/models/AddSampleTypeInput';

export default function createAsync(apiUrl: string) {
  return function api<TResponse>(
    input: AddSampleTypeInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/sample-type-definitions`,
          method: 'POST',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
